import {
	GET_SHARED_TEAM_ROOMS,
	GET_SHARED_TEAM_ROOMS_SUCCESS,
	GET_SHARED_TEAM_ROOMS_FAILURE,
	DELETE_SHARED_TEAM_ROOM,
	DELETE_SHARED_TEAM_ROOM_SUCCESS,
	LOAD_MORE_SHARED_TEAM_ROOMS,
	LOAD_MORE_SHARED_TEAM_ROOMS_SUCCESS,
} from './types';

export const getSharedTeamRoomsAction = () => ({
	type: GET_SHARED_TEAM_ROOMS,
});

export const getSharedTeamRoomsSuccessAction = (payload: any) => ({
	type: GET_SHARED_TEAM_ROOMS_SUCCESS,
	payload,
});

export const getSharedTeamRoomsFailureAction = (error: Error) => ({
	type: GET_SHARED_TEAM_ROOMS_FAILURE,
	payload: error,
});

export const deleteSharedTeamRoomAction = (payload: any) => ({
	type: DELETE_SHARED_TEAM_ROOM,
	payload,
});

export const deleteSharedTeamRoomSuccessAction = (payload: any) => ({
	type: DELETE_SHARED_TEAM_ROOM_SUCCESS,
	payload,
});

export const loadMoreSharedTeamRoomsAction = (payload: any) => ({
	type: LOAD_MORE_SHARED_TEAM_ROOMS,
	payload,
});

export const loadMoreSharedTeamRoomsSuccessAction = (payload: any) => ({
	type: LOAD_MORE_SHARED_TEAM_ROOMS_SUCCESS,
	payload,
});
